/* eslint-disable */
const namespace = 'ruleConfig6'; //命名空间

const GETTABLELIST = `${namespace}gettablelist`; // 获取table数据
const DEL = `${namespace}del`; // 删除
const APLICATIONTYPELIST = `${namespace}aplicationTypeList`; // 删除
const APLICATIONTYPEdetail = `${namespace}aplicationTypeDetail`; // 详情

export { GETTABLELIST, DEL, APLICATIONTYPELIST, APLICATIONTYPEdetail };
